// extracted by mini-css-extract-plugin
export default {"head_title_area":"ResumeHeadTitle_head_title_area__3R5pM","head_btn":"ResumeHeadTitle_head_btn__0sD4P"};